export const TIME_RANGE_CUSTOM_VALUE = 'custom'

export const DEFAULT_TIME_RANGE_VALUE = 'last-24-hour'

export const SERVICE_MAP_TIME_RANGE_VALUES = {
  last30Min: 'last-30-min',
  lastHour: 'last-hour',
  last4Hour: 'last-4-hour',
  last12Hour: 'last-12-hour',
  last24Hour: 'last-24-hour',
  last48Hours: 'last-48-hours',
  last3Days: 'last-3-days',
  last7Days: 'last-7-days',
  last30Days: 'last-30-days',
  custom: TIME_RANGE_CUSTOM_VALUE,
} as const
